import script from "./QuotationCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./QuotationCreate.vue?vue&type=script&setup=true&lang=js"

import "./QuotationCreate.vue?vue&type=style&index=0&id=cab55444&lang=css"

const __exports__ = script;

export default __exports__